import React, { useState, useEffect } from 'react'
import GMap from './Signup/GMap';
import { useLocation, Link } from "react-router-dom";
import axios from 'axios';
import {
	CCard, CCol, CRow, CCardHeader,
	CCardTitle, CCardText, CCardBody,
	CCardSubtitle, CImg, CFooter, CCardImage, CButton
} from 'compat/coreui';
import { IMAGE_URL } from '../Constants/constants';
import { useNavigate } from 'react-router-dom';


function Virginia(props) {
	const navigate = useNavigate()

	const [sellerData, setSellerData] = useState([]);
	const [params, setParams] = useState({});
	const location = useLocation();

	useEffect(() => {
		setParams(location.state || {});
		getBusiness(location.state || {});
	}, [location]);



	const getBusiness = (paramsOne) => {
		axios.get(`${process.env.REACT_APP_APP_API_URL}/api/sellers`, {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('token')
			},
			params: paramsOne
		}).then(res => {
			console.log(res)
			if (res.data.status === 200) {
				setSellerData(res.data.sellers)
			}
		}).catch(console.log)
	}

	const searchHandlerRedirect = (e, search) => {
		e.preventDefault()
		const params = {
			// pincode: "pin",
			sr: search,
		}
		if (search == "STRAINS") {
			navigate("/strain", { state: params })
		} else if (search == "DEALS") {
			navigate("/deals", { state: params })
		} else if (search == "RECREATIONAL") {
			navigate("/search", { state: params })
		} else if (search == "DISPENSARIES") {
			navigate("/search", { state: params })
		}else if (search == "DELIVERIES") {
			navigate("/search", { state: params })
		}
	}
	return (
		<>
			<div>
				<div className="virginia_map hideCol">
					<GMap />
				</div>
				<div className="body_wrap has_map">
					<div className="site_nav">
						<ul>
							<li className="active">
								<a href="#" data-suffix="/virginia/dulles/marijuana-dispensaries"><span>Dispensaries</span></a>
							</li>
							<li>
								<a href="#" data-suffix="/virginia/dulles/marijuana-dispensaries/delivery"><span>Deliveries</span></a>
							</li>
							<li>
								<a href="#" data-suffix="/virginia/dulles/marijuana-doctors"><span>Doctors</span></a>
							</li>
							<li>
								<a href="#" data-suffix="/marijuana-dispensary-deals"><span>Deals</span></a>
							</li>
							{/*-<li>
											<a href="/virginia/dulles/online-ordering" data-suffix="/online-ordering" className="oo">
													<span>Order Online</span>
											</a>
										</li>-*/}
							<li>
								<a href="#" data-tab="strains">
									<span>Strains</span>
								</a>
							</li>
							<li>
								<a href="#" data-tab="blog">
									<span>Blog</span>
								</a>
							</li>
						</ul>
						<div className="hap_cta" onClick="hap_cta_open();">
							<img src="/images/app_cta_sm.jpg" />
							<div className="cta">Get the app</div>
						</div>
						{/*<div className="hap_cta_panel sms_form">
									<form method="POST">
										<div className="hap_panel">
											<div className="heading">Enter your phone number below to receive a link to the app store!</div>
											<input type="text" className="number" name="phone" placeholder="(555) 555-5555" autoComplete="off" aria-label="phone number" />
											<input type="submit" defaultValue="Send" />
										</div>
									</form>
								</div>*/}
					</div>
					<div>
						<div className="content_wrap">
							<div className="wrapper main homepage dont_offset" data-id="dulles_20101">
								<ul className="tablet_filters">
									<li><label><a href="#"><span className="icon-star" /> Sort By</a></label></li>
									<li><label><a href="#"><span className="icon-star" /> Types</a></label></li>
									<li><label><a href="#"><span className="icon-star" /> Specials</a></label></li>
									<li><label><a href="#"><span className="icon-star" /> Menus</a></label></li>
									<li><label><a href="#"><span className="icon-star" /> Features</a></label></li>
								</ul>
								<div className="c_2 sidebar_filter" id="filter_view"><span className="filters_head">Filter your search results</span>
									<div className="seller-details m-5">
										<CRow>
											{sellerData.map((item, index) => {
												return (<CCol sm="12" className="m-auto" key={index}>
													<Link to={"/businessnew/" + item._id}>
														<CCard>
															<CCardBody >
																<CRow style={{ margin: "0px" }}>
																	<div style={{ width: "15%" }}>
																		{item.image ? <CCardImage src={IMAGE_URL + item.image} /> : <CCardImage src="/images/product-1.jpg" />}
																	</div>
																	<CCol>
																		<CRow>
																			<p style={{ width: "80%" }}>{item.businessName}</p>
																			<CCardImage style={{ width: "7%" }} src="/images/cart.svg" />
																		</CRow>
																		<CRow>
																			<CButton style={{ border: "solid", borderWidth: "1px" }}>4.3 <i class="fa fa-star-half-o" aria-hidden="true"></i></CButton>
																			<span style={{marginLeft:"10px"}}>{item.businessType}</span><br />
																		</CRow>
																	</CCol>
																</CRow>
															</CCardBody>
															{/* <CFooter className="b-footer">
																<p><span>$700</span> 4 oz Topshelf,free delivery and Gift 🎁</p>
															</CFooter> */}
														</CCard>
													</Link>
												</CCol>)
											}
											)}
										</CRow>
									</div>
									{/*<div className="sidebar_filter_wrap"><ul className="ul_wrap">
												<li className="heading" style={{display: 'none'}} data-label="sort_by"><ul><li className="active_value sort_by_placeholder" /></ul></li>
												<li className="filter_value" data-value="delivery"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Delivery</a></label></li>
												<li className="filter_value" data-value="online-ordering"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Online Ordering</a></label></li>
												<li className="filter_value" data-value="open-now"><label><input type="checkbox" /><span className="checkbox_sq" />
												 <a href="#">Open Now</a></label>
												</li>
												<li className="morefilters">
														<span className="morefilters_label">More Filters</span>
												</li>
												<li className="more_filters_container">
														<ul className="more_filters_container">
																<li className="sort_by">
																	<label style={{display: 'none'}}>Sort by:</label>
																	<select id="sort_by_select" aria-label="Sort By" onchange="get_filter_values($(this));">
																		<option value="popular">Most Popular</option>
																		<option value="distance">Distance</option>
																		<option value="most-viewed">Most Viewed</option>
																		<option value="best-rated">Best Rating</option>
																	</select>
																</li>
														<li className="heading active" id="filter_type" data-filter="type" data-label="Types">
															<label><span className="filter_label icon-administration icon" /> Types</label>
															<ul className>
																<li className="filter_value active_value" data-value="marijuana-dispensaries"><label><input type="checkbox" defaultChecked /><span className="checkbox_sq" /> <a href="/virginia/dulles/20101">Dispensary / Co-Ops</a></label></li>
																<li className="filter_value" data-value="marijuana-doctors"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">MMJ Doctors</a></label></li>
															</ul>
														</li>
														<li className="heading" id="filter_amenities" data-filter="amenities" data-label="Amenities">
															<label><span className="filter_label icon-tick7 icon" /> Amenities</label>
															<ul className>
																<li className="filter_value" data-value="accepts-credit-cards"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Accepts CCs</a></label></li>
																<li className="filter_value" data-value="has-atms"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Has ATMs</a></label></li>
																<li className="filter_value" data-value="has-security"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Security Available</a></label></li>
																<li className="filter_value" data-value="wheelchair-accessible"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Wheelchair Accessible</a></label></li>
																<li className="filter_value" data-value="onsite-smoking"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Onsite Smoking</a></label></li>
																<li className="filter_value" data-value="veteran-discount"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Discount for Veterans</a></label></li>
																<li className="filter_value" data-value="ill-discount"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Terminal Patient Discount</a></label></li>
															</ul>
														</li><li className="heading" id="filter_specials" data-filter="specials" data-label="Specials">
															<label><span className="filter_label icon-price-tag5 icon" /> Specials</label>
															<ul className>
																<li className="filter_value" data-value="bud-deals"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Flower</a></label></li>
																<li className="filter_value" data-value="concentrate-deals"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Concentrates</a></label></li>
																<li className="filter_value" data-value="edible-deals"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Edibles</a></label></li>
																<li className="filter_value" data-value="preroll-deals"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Prerolls</a></label></li>
																<li className="filter_value" data-value="vaporizer-deals"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Vaporizers</a></label></li>
																<li className="filter_value" data-value="other-deals"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Other</a></label></li>
															</ul>
														</li><li className="heading" id="filter_menus" data-filter="menus" data-label="Menus">
															<label><span className="filter_label icon-document9 icon" /> Menus</label>
															<ul className>
																<li className="filter_value" data-value="indicas"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Has Indicas</a></label></li>
																<li className="filter_value" data-value="sativas"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Has Sativas</a></label></li>
																<li className="filter_value" data-value="hybrids"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Has Hybrids</a></label></li>
																<li className="filter_value" data-value="concentrates"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Has Concentrates</a></label></li>
																<li className="filter_value" data-value="edibles"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Has Edibles</a></label></li>
																<li className="filter_value" data-value="prerolls"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Has Prerolls</a></label></li>
																<li className="filter_value" data-value="clones"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Has Clones</a></label></li>
																<li className="filter_value" data-value="seeds"><label><input type="checkbox" /><span className="checkbox_sq" /> <a href="#">Has Seeds</a></label></li>
															</ul>
														</li><li className="heading" id="filter_events" data-filter="events" data-label="Events" style={{display: 'none'}}>
															<label><span className="filter_label icon-location icon" /> Events</label>
															<ul className>
															</ul>
														</li></ul></li>
											</ul></div>*/}
								</div>
								<ul className="mobile_tabs">
									<li className="active" data-id="listing_view"><a href="#"><span className="icon-list" /> Listings</a></li><li data-id="map_view"><a href="#"><span className="icon-map3" /> Map</a></li><li data-id="filter_view"><a href="#"><span className="icon-filter" /> Filters</a></li>
								</ul>
								<div className="c_10 card_wrap mobile_view active" id="listing_view">
									<div id="sub_content">
										<div className="mobile_grid">
											<div className="inner" >
												<div className="heading">Suggested in Dulles</div>
												<ul>
													<li className="strains" onClick={e => { searchHandlerRedirect(e, 'STRAINS') }}>
														<a href="/strains_mobile.php" rel="nofollow">
															<label>Strains</label></a>
													</li>
													<li className="deals" onClick={e => { searchHandlerRedirect(e, 'DEALS') }}>
														<a href="/virginia/dulles/20101/marijuana-dispensary-deals">
															<label>Deals</label></a>
													</li>
													<li className="recreational" onClick={e => { searchHandlerRedirect(e, 'RECREATIONAL') }}>
														<a href="/virginia/dulles/20101/marijuana-dispensaries/recreational">
															<label>Recreational</label></a>
													</li>
													<li className="dispensaries" onClick={e => { searchHandlerRedirect(e, 'DISPENSARIES') }}>
														<a href="/virginia/dulles/20101/marijuana-dispensaries">
															<label>Dispensaries</label></a>
													</li>
													<li className="deliveries" onClick={e => { searchHandlerRedirect(e, 'DELIVERIES') }}>
														<a href="/virginia/dulles/20101/marijuana-dispensaries/delivery">
															<label>Deliveries</label></a>
													</li>
													<li className="doctors" onClick={e => { searchHandlerRedirect(e, 'DELIVERIES') }}>
														<a href="/virginia/dulles/20101/marijuana-doctors">
															<label>Doctors</label></a>
													</li>
													<li className="oo">
														<a href="/virginia/dulles/20101/online-ordering">
															<label>Online Ordering</label></a>
													</li>
												</ul>
											</div>
										</div>
										<div className="clear" />
									</div>
								</div>
								<span className="mobile_view" id="map_view" />
								<div className="clear" />
								<div className="clear" />
							</div>
						</div>
						<div className="index_none2 remove_onreload">
							<div className="news_wrap">
								<div className="wrapper">
									<h2>Dulles Marijuana News &amp; Events</h2>
									<ul>
										<li>
											<a href="#">
												<div className="img_wrap">
													<picture><img src="images/c.jpg" alt="Movement Toward Cannabis" /></picture>
													<h4>Movement Toward Cannabis Appellations: Why It's Important</h4>
												</div>
												<div className="cat_wrap business"><span>Education</span></div>
												<div className="date">December 21, 2020</div>
												<div className="split"><span /></div>
												<p>The cannabis industry has been rapidly growing since the first few states legalized recreational marijuana. Now that there are 15 fully legalized states and 35 states with legalized medical marijuana, it's more important than ever to create systems o...</p>
											</a>
										</li>
										<li>
											<a href="#">
												<div className="img_wrap">
													<picture>
														<img src="images/w.png" alt="Weed" />
													</picture>
													<h4>Why is France Giving Away Free Weed?</h4>
												</div>
												<div className="cat_wrap business"><span>Education</span></div>
												<div className="date">December 20, 2020</div>
												<div className="split"><span /></div>
												<p>French marijuana laws are conservative, especially when compared to other countries in the European Union. However, this month the French government released a&nbsp;decree detailing the country's plan for a limited medical marijuana experiment&nbsp;t...</p>
											</a>
										</li>
										<li>
											<a href="#">
												<div className="img_wrap">
													<picture>
														<img src="images/holiday.png" alt="Top 5 Holiday Movies to Smoke Weed With" /></picture>
													<h4>Top 5 Holiday Movies to Smoke Weed With</h4>
												</div>
												<div className="cat_wrap business"><span>Culture</span></div>
												<div className="date">December 19, 2020</div>
												<div className="split"><span /></div>
												<p>Stoners absolutely love Christmas (or at least they should), and there are multiple reasons why: It's a national holiday so there's typically no work or school for a day or two. There's yummy food for Christmas dinner, as well as giving and receiving...</p>
											</a>
										</li>
										<li>
											<a href="#">
												<div className="img_wrap">
													<picture>
														<img src="images/smoke.png" alt="Top 7 Strains to Smoke this Holiday Season" /></picture>
													<h4>Top 7 Strains to Smoke this Holiday Season</h4>
												</div>
												<div className="cat_wrap business"><span>Strains &amp; Products</span></div>
												<div className="date">December 18, 2020</div>
												<div className="split"><span /></div>
												<p>COVID-19 has made this year a bit of a whirlwind, and it doesn't look like it is going to stop anytime soon. With the latest closures and possible cancellation of our beloved holidays, we all need a little something to take the edge off. Our favorite...</p>
											</a>
										</li>
									</ul>
									<div className="more_cta"><a href="#"><span>More Articles</span></a></div>
								</div>
							</div>
							<div className="slide_split app_slide">
								<div className="wrapper">
									<div className="c_6 app_img"><img src="/images/app_cta.png" alt="App Homescreen" /></div>
									<div className="c_6 app_text">
										<h3>Get the app</h3>
										<p>Discover local businesses. Find the best deals. <span>Connect &amp; share with friends.</span></p>
										<ul className="app_links">
											<li className="app_logo"><a href="#" target="_blank" rel="noopener"><img src="/images/ply-str.png" alt="Android App" /></a></li>
											<li className="app_logo"><a href="#" target="_blank" rel="noopener"><img src="/images/ap-str.png" alt="iOS App" /></a></li>
											<li className="app_logo"><a href="#" target="_blank" rel="noopener"><img src="/images/wnd-str.png" alt="WindowsPhone App" /></a></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}


export default Virginia;